var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-card"},[_c('header',{staticClass:"details-card__header is-flex is-vcenter"},[_vm._t("header")],2),_c('div',[_vm._t("main")],2),_c('footer',{staticClass:"details-card__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }